export const browserNotificationsSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window;

export const getBrowserNotificationPermission = (): NotificationPermission | 'unsupported' => {
  if (!browserNotificationsSupported()) {
    return 'unsupported';
  }
  return Notification.permission;
};

export const requestBrowserNotifications = async (): Promise<NotificationPermission | 'unsupported'> => {
  if (!browserNotificationsSupported()) {
    return 'unsupported';
  }
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Notification.permission;
  }
  return Notification.requestPermission();
};

export const showBrowserNotification = (title: string, options?: NotificationOptions) => {
  if (!browserNotificationsSupported() || Notification.permission !== 'granted') {
    return;
  }

  try {
    const notification = new Notification(title, {
      icon: '/UptimioHelpdesk.png',
      ...options
    });
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
  } catch (error) {
    console.warn('Browser notification could not be shown', error);
  }
};
